import { ControlProps, isControl, rankWith } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { Toggle } from "rsuite";

const ToggleRenderer = (props: ControlProps) => {
  return (
    <div className="control">
      <label> {props.label}</label>
      <div className="toggle">
        <Toggle
          size="md"
          disabled
          checked={props.data}
          checkedChildren={props?.uischema?.options?.trueValue ?? "true"}
          unCheckedChildren={props?.uischema?.options?.falseValue ?? "False"}
        />
      </div>
    </div>
  );
};

export const toggleRendererTester = rankWith(100, (uischema) => {
  if (!isControl(uischema)) return false;
  return uischema.options?.variant === "toggle";
});

export default withJsonFormsControlProps(ToggleRenderer);
